import { Typography } from 'antd';
import React from 'react';
import { ResultsSummaryProps } from '../find-taxpayer-service.type';
import { localize } from '/react4xp/mixins/helpers';

export function ResultsSummary({ translations, resultsCount, total }: ResultsSummaryProps) {
    return (
        <>
            <h3 className="response__title">
                {translations && localize('print-form.search-results', translations)}
            </h3>

            {resultsCount < total ? (
                <Typography.Paragraph
                    type="danger"
                    strong
                >
                    {translations &&
                        localize('print-form.results-limit', translations).replaceAll(
                            '__LIMIT__',
                            resultsCount.toString()
                        )}
                </Typography.Paragraph>
            ) : (
                <Typography.Paragraph className="response__total">
                    {translations && localize('print-form.found', translations)}
                    {' ' + resultsCount}
                </Typography.Paragraph>
            )}
        </>
    );
}
